import { Alert, Box, Grid } from '@mui/material';
import { useState, useEffect } from 'react';
import { isDataSetEmpty } from '../utils/graph-utils';

// takes graph data as children

export default function NoGraphData({ data, type, children, year, variant }) {
    const [noDataMessage, setNoDataMessage] = useState(null);

    useEffect(() => {
        const dataSetIsEmpty = isDataSetEmpty(data, variant);
        if (dataSetIsEmpty) {
            setNoDataMessage(`No ${type} data available for ${year}`)
        }
        else setNoDataMessage(null);

    }, [data, type, year, variant]);

    return (
        <Grid container sx={{ gap: { xs: 5, xl: 0 }, pb: 3 }}>
            {noDataMessage ?
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', width: '100%' }}>
                    <Alert sx={{ m: 1, alignSelf: "center" }} severity='info'>{noDataMessage}</Alert>
                </Box> :
                children}
        </Grid>
    )
}